<template>
    <div class="parentQues">
        <el-form :model="form" :rules="rules" ref="form"  class="content" label-position="left" >
            <div class="main_box">
                <p class="question_title">家长基本信息</p>
                <div class="main">
                    <el-row type="flex"  justify="space-between">
                        <el-col :span="10" >
                            <el-form-item label="母亲职业：" prop="motherOccupation">
                                <el-input v-model="form.motherOccupation" maxLength='25'></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="10">
                            <el-form-item label="工作单位：" prop="motherEmployer">
                                <el-input v-model="form.motherEmployer" maxLength='25' ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row type="flex"  justify="space-between">
                        <el-col :span="10" >
                            <el-form-item label="父亲职业：" prop="dadOccupation">
                                <el-input v-model="form.dadOccupation" maxLength='25' ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="10">
                            <el-form-item label="工作单位：" prop="dadEmployer">
                                <el-input v-model="form.dadEmployer" maxLength='25' ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row type="flex" >
                        <el-col :span="11">
                            <el-form-item label="家庭类型：" prop="familyTypeRadio">
                                <el-radio-group v-model="form.familyTypeRadio">
                                    <el-radio label="正常"></el-radio>
                                    <el-radio label="重建"></el-radio>
                                    <el-radio label="单亲"></el-radio>
                                    <el-radio label="其他"></el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                        <el-col :span="13">
                            <el-form-item  prop="familyType"  v-if="form.familyTypeRadio=='其他'" >
                                <el-input v-model="form.familyType" maxLength={25} ></el-input>
                            </el-form-item>
                            <el-form-item v-else >
                                <el-input disabled></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="6" >
                            <el-form-item label="是否独生：" prop="isOnlyChildRadio">
                                <el-radio-group v-model="form.isOnlyChildRadio">
                                    <el-radio label="是"></el-radio>
                                    <el-radio label="不是"></el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                        <el-col :span="18">
                            <el-form-item label="其他孩子与学生的关系" prop="familyType"  label-width="170px" v-if="form.isOnlyChildRadio=='不是'" >
                                <el-input v-model="form.isOnlyChild" maxLength={25} ></el-input>
                            </el-form-item>
                            <el-form-item v-else label="其他孩子与学生的关系：" label-width="170px" >
                                <el-input disabled></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
            </div>



            <div class="main_box">
                <p class="question_title">学生个人情况</p>
                <div class="main">
                    <el-form-item  prop="studentHobby"  label="孩子的兴趣爱好："  label-width="150px">
                        <el-input v-model="form.studentHobby" maxLength={100} ></el-input>
                    </el-form-item>
                    <el-form-item  prop="studentAdvantage"  label="孩子的优点：" label-width="150px">
                        <el-input v-model="form.studentAdvantage" maxLength={100} ></el-input>
                    </el-form-item>
                    <el-form-item  prop="studentdisadvantage"  label="孩子的缺点：" label-width="150px">
                        <el-input v-model="form.studentdisadvantage" maxLength={100} ></el-input>
                    </el-form-item>
                    <el-form-item  prop="studentBestFirend"  label="孩子最好的朋友：" label-width="150px">
                        <el-input v-model="form.studentBestFirend" maxLength={100} ></el-input>
                    </el-form-item>
                    <el-form-item  prop="studentLikeBook"  label="孩子喜欢的书：" label-width="150px">
                        <el-input v-model="form.studentLikeBook" maxLength={100} ></el-input>
                    </el-form-item>
                    <el-form-item  prop="studentLikeMovie"  label="孩子喜欢的电影：" label-width="150px">
                        <el-input v-model="form.studentLikeMovie" maxLength={100} ></el-input>
                    </el-form-item>
                    <el-form-item  prop="studentLikeStar"  label="孩子喜欢的明星：" label-width="150px">
                        <el-input v-model="form.studentLikeStar" maxLength={100} ></el-input>
                    </el-form-item>
                    <el-form-item  prop="studentLookOccupation"  label="孩子向往的职业：" label-width="150px">
                        <el-input v-model="form.studentLookOccupation" maxLength={100} ></el-input>
                    </el-form-item>

                    <el-form-item  prop="studentLookMajor"  label="孩子向往的专业：" label-width="150px">
                        <el-input v-model="form.studentLookMajor" maxLength={100} ></el-input>
                    </el-form-item>
                    <el-form-item  prop="studentlookUniversity"  label="孩子向往的大学：" label-width="150px">
                        <el-input v-model="form.studentlookUniversity" maxLength={100} ></el-input>
                    </el-form-item>
                    <el-form-item  prop="studentPhysicalQuality"  label="孩子的身体素质：" label-width="150px">
                        <el-input v-model="form.studentPhysicalQuality" maxLength={100} ></el-input>
                    </el-form-item>
                </div>
            </div>

            <div class="main_box student_study">
                <p class="question_title">学生学习情况</p>
                <div class="main">
                    <el-form-item label="主管孩子学习：" prop="learnManageStudent" label-width="130px">
                        <el-radio-group v-model="form.learnManageStudent">
                            <el-radio v-for="(item,index) in ['父亲','母亲','其他']" :label="item" :key="index"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="陪同完成作业：" prop="learnAccompany" label-width="130px">
                        <el-radio-group v-model="form.learnAccompany">
                            <el-radio v-for="(item,index) in ['会','偶尔','不会']" :label="item" :key="index"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="辅导孩子作业：" prop="learnTutoring" label-width="130px">
                        <el-radio-group v-model="form.learnTutoring">
                            <el-radio v-for="(item,index) in ['会','偶尔','不会']" :label="item" :key="index"></el-radio>
                        </el-radio-group>
                    </el-form-item>

                    <el-form-item label="检查孩子作业：" prop="learnCheckHomework" label-width="130px">
                        <el-radio-group v-model="form.learnCheckHomework">
                            <el-radio v-for="(item,index) in ['会','偶尔','不会']" :label="item" :key="index"></el-radio>
                        </el-radio-group>
                    </el-form-item>


                    <el-form-item label="孩子预习情况：" prop="learnPreview" label-width="130px">
                        <el-radio-group v-model="form.learnPreview">
                            <el-radio v-for="(item,index) in ['不预习','偶尔预习','经常预习','一直预习']" :label="item" :key="index"></el-radio>
                        </el-radio-group>
                    </el-form-item>


                    <el-form-item label="孩子课堂效果：" prop="learnClassEffect" label-width="130px">
                        <el-radio-group v-model="form.learnClassEffect">
                            <el-radio v-for="(item,index) in ['不听课','经常走神','偶尔走神','认真听课']" :label="item" :key="index"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="孩子课堂笔记：" prop="learnClassNotes" label-width="130px">
                        <el-radio-group v-model="form.learnClassNotes">
                            <el-radio v-for="(item,index) in ['不做笔记','偶尔做笔记','经常做笔记','一直做笔记']" :label="item" :key="index"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="孩子复习情况：" prop="learnReview" label-width="130px">
                        <el-radio-group v-model="form.learnReview">
                            <el-radio v-for="(item,index) in ['不复习','偶尔复习','经常复习','一直复习']" :label="item" :key="index"></el-radio>
                        </el-radio-group>
                    </el-form-item>

                    <el-form-item label="孩子每天的作业练习，遇到不懂的题目，你是当天一定要想办法解决掉，还是以后再说？："  label-width="970" prop="learnProblem" class="labelBlock">
                        <el-radio-group v-model="form.learnProblem">
                            <el-radio v-for="(item,index) in ['从不','偶尔解决','经常解决','一定解决']" :label="item" :key="index"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="孩子考试情况：" prop="learnExamSituation" label-width="130px">
                        <el-radio-group v-model="form.learnExamSituation">
                            <el-radio v-for="(item,index) in ['总紧张','偶尔紧张','很少紧张','轻松应对']" :label="item" :key="index"></el-radio>
                        </el-radio-group>
                    </el-form-item>

                    <el-form-item label="孩子学习成绩：" prop="learnGrades" label-width="130px">
                        <el-radio-group v-model="form.learnGrades">
                            <el-radio v-for="(item,index) in ['波动大','有些波动','比较稳定','十分稳定']" :label="item" :key="index"></el-radio>
                        </el-radio-group>
                    </el-form-item>


                    <el-form-item label="孩子反映课堂：" prop="learnFeedbackClass" label-width="130px">
                        <el-radio-group v-model="form.learnFeedbackClass">
                            <el-radio v-for="(item,index)  in ['听不懂','听不太懂','基本听懂','完全听懂']" :label="item" :key="index"></el-radio>
                        </el-radio-group>
                    </el-form-item>



                    <el-row type="flex" justify="space-between"  class="radioBox">
                        <el-col :span="9" >
                            <el-form-item label="孩子是否参加课外班：" prop="learnIsJoinCarm" class="radioBox">
                                <el-radio-group v-model="form.learnIsJoinCarm">
                                    <el-radio label="是"></el-radio>
                                    <el-radio label="否"></el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                        <el-col :span="14">
                            <el-form-item  label="参与学科" prop="learnIsJoinCarmSubject"  v-if="form.learnIsJoinCarm=='是'" >
                                <el-input v-model="form.learnIsJoinCarmSubject" maxLength={25} placeholder="请输入学科名称"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row type="flex" justify="space-between"  class="radioBox"  style="margin-top: -18px">
                        <el-col  :span="9">
                            <el-form-item label="孩子是否参加兴趣培训服务：" prop="learnIsJoinHobby">
                                <el-radio-group v-model="form.learnIsJoinHobby">
                                    <el-radio label="是"></el-radio>
                                    <el-radio label="否"></el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                        <el-col :span="14">
                            <el-form-item  label="兴趣班或特长" prop="learnIsJoinHobbyClass"  v-if="form.learnIsJoinHobby=='是'" >
                                <el-input v-model="form.learnIsJoinHobbyClass" maxLength={25} placeholder="请输入兴趣班或特长班名称" ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>


                    <el-form-item  prop="learnAdvantage"  label="孩子学习上的优势：" label-width="160px">
                        <el-input v-model="form.learnAdvantage" maxLength={100} ></el-input>
                    </el-form-item>

                    <el-form-item label="影响孩子学习的因素（可多选）" prop="learnInfluenceFactorList" class="labelBlock">
                        <el-checkbox-group v-model="form.learnInfluenceFactorList">
                            <el-checkbox v-for="(item,index) in ['学习投入（专注与精力）','学习策略（组织与记忆）','时间管理','执行力','压力应对','考试应考（技巧与心理）','学习动力','学习意志力','学习效能感','成就动机','人际关系','学习积极性','其他']" :label="item" name="learnInfluenceFactorList" :key="index"></el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                </div>
            </div>
            <div class="main_box">
                <p class="question_title">日常生活部分</p>
                <div class="labelBlock main">
                    <el-form-item label="最近和孩子一起开展的亲子活动/一起看的书或电影：" prop="lifeActivity">
                        <el-input type="textarea" v-model="form.lifeActivity" maxLength={200} ></el-input>
                    </el-form-item>
                    <el-form-item label="孩子近期做过的最让您或您的家人感动的事：" prop="lifeMoved">
                        <el-input type="textarea" v-model="form.lifeMoved" maxLength={200} ></el-input>
                    </el-form-item>
                    <el-form-item label="您与孩子之间是否存在交流沟通方面的问题？（若有，请简要描述；若无，请填写“无”）" prop="lifeExchange">
                        <el-input type="textarea" v-model="form.lifeExchange" maxLength={200} ></el-input>
                    </el-form-item>
                    <el-form-item label="孩子成长（学习&生活）过程中最让您担心的是：" prop="lifeWorry">
                        <el-input type="textarea" v-model="form.lifeWorry" maxLength={200} ></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="main_box">
                <p class="question_title">未来规划部分</p>
                <div class="main">
                    <p class="main_detail">关于孩子的高考升学，您是否已有规划？</p>
                    <el-form-item label="理想专业（方向）：" prop="futureMajor">
                        <el-input v-model="form.futureMajor" maxLength={100} ></el-input>
                    </el-form-item>
                    <el-form-item label="理想大学（城市）：" prop="futureUniversity">
                        <el-input v-model="form.futureUniversity" maxLength={100} ></el-input>
                    </el-form-item>
                    <el-form-item label="高考路径（升学）：" prop="futureEducation">
                        <el-input v-model="form.futureEducation" maxLength={100} ></el-input>
                    </el-form-item>
                    <el-form-item label="就此规划，您与孩子是否达成一致？若否，请说明矛盾冲突点：" prop="futureConflict" class="labelBlock">
                        <el-input type="textarea" v-model="form.futureConflict" maxLength={200} ></el-input>
                    </el-form-item>
                </div>
            </div>


            <div class="main_box">
                <p class="question_title">学业规划期待</p>
<!--                <p class="main_detail">学业规划期待</p>-->
                <div class="main">
                    <el-form-item label="您期待在经历系统的学业规划服务后，学生在哪些方面会有提升？" prop="studyGradesUp" class="labelBlock">
                        <el-input type="textarea" v-model="form.studyGradesUp" maxLength={200} ></el-input>
                    </el-form-item>
                </div>
            </div>


            <div class="main_box">
                <p class="question_title">其他部分</p>
<!--                <p class="main_detail">其他部分</p>-->
                <div class="labelBlock main">
                    <el-form-item label="您希望孩子在学习之外哪些方面得到提升？（可多选）" prop="otherPromote">
                        <el-checkbox-group v-model="form.otherPromote">
                            <el-checkbox v-for="(item,index) in ['沟通交际能力','自我认识及兴趣探索方向','大学专业探索','社会实践','公益活动','其他']" :label="item" name="otherPromote" :key="index"></el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item label="您认为在指导孩子的过程中，您需要补充哪些方面的内容？（可多选）" prop="otherSupplement">
                        <el-checkbox-group v-model="form.otherSupplement">
                            <el-checkbox v-for="(item,index) in ['高考改革政策解读','生涯规划理论及操作','选科策略（参考因素）','大学及专业介绍','中学生综合素质培养','职业行业介绍','高考之外的升学路径介绍','其他']" :label="item" name="otherSupplement" :key="index"></el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item label="您觉得我们需要了解孩子的特殊情况，请说明：" prop="otherAspect">
                        <el-input type="textarea" v-model="form.otherAspect" maxLength={200} ></el-input>
                    </el-form-item>
                </div>
            </div>
        </el-form>
        <div class="btnBox" style="display: flex;justify-content: space-around;padding: 45px 0px;width: 300px;margin: 0px auto;">
            <Button @handleClick="submitForm('form')" :type="'btnGray'" name="保存" ></Button>
        </div>
        <ParentPopup v-show="isShowPopup"  @closePop="isShowPopup=false" @finish="isFinishPop=true"></ParentPopup>
    </div>

</template>

<script>
import ParentPopup from './parentPopup.vue';
import Button from '@/components/Button.vue'
export default {
    name: "parentQues",
    components:{ ParentPopup,Button },
    data() {
        return {
            isShowPopup:false,
            isFinishPop:true,
            status: 1,
            form: {
                motherOccupation: '',
                motherEmployer: '',
                dadOccupation: '',
                dadEmployer: '',
                familyTypeRadio: '',
                familyType: '',
                isOnlyChildRadio: '',
                isOnlyChild: '',

                // 学生个人情况
                studentHobby: '', //兴趣爱好
                studentAdvantage: '', //优点
                studentdisadvantage: '', //缺点
                studentBestFirend: '', //最好的朋友
                studentLikeBook: '', //喜欢的书
                studentLikeMovie: '', //喜欢的电影
                studentLikeStar: '', //喜欢的明星
                studentLookOccupation: '', //向往的职业
                studentLookMajor: '', //向往的专业
                studentlookUniversity: '', //向往的大学
                studentPhysicalQuality: '', //身体素质



                // 学生学习情况 learn
                learnManageStudent: '',//主管孩子学习
                learnAccompany: '',//陪同完成作业
                learnTutoring: '',//辅导孩子作业
                learnCheckHomework: '',//检查孩子作业
                learnPreview: '',//孩子预习情况
                learnClassEffect: '',//孩子课堂效果
                learnClassNotes: '',//孩子课堂笔记
                learnReview: '',//孩子复习情况
                learnProblem: '',//孩子每天的作业练习，遇到不懂的题目，你是当天一定要想办法解决掉，还是以后再说？
                learnExamSituation: '',//孩子考试情况
                learnGrades: '',//孩子学习成绩
                learnFeedbackClass: '',//孩子反映课堂
                learnIsJoinCarm: '',//孩子是否参加课外班,是，否
                learnIsJoinCarmSubject: '',//参加课外班学科
                learnIsJoinHobby: '',//是否参加兴趣培训服务
                learnIsJoinHobbyClass: '',//兴趣班培训服务，是，否
                learnAdvantage: '',//孩子学习上的优势
                learnInfluenceFactorList: [],// 影响孩子学习的因素（可多选）




                // 日常生活部分
                lifeActivity: '',//最近和孩子一起开展的亲子活动/一起看的书或电影：
                lifeMoved: '',//孩子近期做过的最让您或您的家人感动的事
                lifeExchange: '',//您与孩子之间是否存在交流沟通方面的问题？（若有，请简要描述；若无，请填写“无”））
                lifeWorry: '',//孩子成长（学习&生活）过程中最让您担心的是



                // 未来规划部分
                futureMajor: '',//理想专业（方向）
                futureUniversity: '',//理想大学（城市）
                futureEducation: '',//高考路径（升学）
                futureConflict: '',//就此规划，您与孩子是否达成一致？若否，请说明矛盾冲突点：


                // 学业规划期待
                studyGradesUp: '',//您期待在经历系统的学业规划服务后，学生在哪些方面会有提升？
                // 其他部分
                otherPromote: [],//您希望孩子在学习之外哪些方面得到提升？（可多选）
                otherSupplement: [],//您认为在指导孩子的过程中，您需要补充哪些方面的内容？（可多选）
                otherAspect: '',//您觉得我们需要了解孩子的特殊情况？


            },
            rules: {
                motherOccupation: [
                    { required: true, message: '请填写该内容', trigger: 'blur' },
                ],
                motherEmployer: [
                    { required: true, message: '请填写该内容', trigger: 'blur' },
                ],
                dadOccupation: [
                    { required: true, message: '请填写该内容', trigger: 'blur' },
                ],
                dadEmployer: [
                    { required: true, message: '请填写该内容', trigger: 'blur' },
                ],
                familyTypeRadio: [
                    { required: true, message: '请选择', trigger: 'change' },
                ],
                familyType: [
                    { required: true, message: '请填写该内容', trigger: 'blur' },
                ],
                isOnlyChildRadio: [
                    { required: true, message: '请选择', trigger: 'change' },
                ],
                isOnlyChild: [
                    { required: true, message: '请选择', trigger: 'blur' },
                ],



                studentHobby: [
                    { required: true, message: '请输入兴趣爱好', trigger: 'blur'}
                ],
                studentAdvantage: [
                    { required: true, message: '请输入孩子的优点', trigger: 'blur' }
                ],
                studentdisadvantage: [
                    { required: true, message: '请输入孩子的缺点', trigger: 'blur' }
                ],
                studentBestFirend: [
                    { required: true, message: '请输入孩子最好的朋友', trigger: 'blur' }
                ],
                studentLikeBook: [
                    { required: true, message: '请输入孩子喜欢的书', trigger: 'blur'}
                ],
                studentLikeMovie: [
                    { required: true, message: '请输入孩子喜欢的电影', trigger: 'blur' }
                ],
                studentLikeStar: [
                    { required: true, message: '请输入孩子喜欢的明星', trigger: 'blur' }
                ],
                studentLookOccupation: [
                    { required: true, message: '请输入孩子向往的职业', trigger: 'blur' }
                ],
                studentLookMajor: [
                    { required: true, message: '请输入孩子向往的专业', trigger: 'blur' }
                ],
                studentlookUniversity: [
                    { required: true, message: '请输入孩子向往的大学', trigger: 'blur' }
                ],
                studentPhysicalQuality: [
                    { required: true, message: '身体素质', trigger: 'blur'}
                ],




                learnManageStudent: [
                    { required: true, message: '请选择', trigger: 'change'}
                ],
                learnAccompany: [
                    { required: true, message: '请选择', trigger: 'change'}
                ],
                learnTutoring: [
                    { required: true, message: '请选择', trigger: 'change'}
                ],
                learnCheckHomework: [
                    { required: true, message: '请选择', trigger: 'change'}
                ],
                learnPreview: [
                    { required: true, message: '请选择', trigger: 'change'}
                ],
                learnClassEffect: [
                    { required: true, message: '请选择', trigger: 'change'}
                ],
                learnClassNotes: [
                    { required: true, message: '请选择', trigger: 'change'}
                ],
                learnReview: [
                    { required: true, message: '请选择', trigger: 'change'}
                ],
                learnProblem: [
                    { required: true, message: '请选择', trigger: 'change'}
                ],
                learnExamSituation: [
                    { required: true, message: '请选择', trigger: 'change'}
                ],
                learnGrades: [
                    { required: true, message: '请选择', trigger: 'change'}
                ],
                learnFeedbackClass: [
                    { required: true, message: '请选择', trigger: 'change'}
                ],
                learnIsJoinCarm: [
                    { required: true, message: '请选择', trigger: 'change'}
                ],
                learnIsJoinCarmSubject: [
                    { required: true, message: '请填写', trigger: 'blur'}
                ],
                learnIsJoinHobby: [
                    { required: true, message: '请选择', trigger: 'change'}
                ],
                learnIsJoinHobbyClass: [
                    { required: true, message: '请填写', trigger: 'blur'}
                ],
                learnAdvantage: [
                    { required: true, message: '请填写', trigger: 'blur'}
                ],
                learnInfluenceFactorList: [
                    { required: true, message: '请选择', trigger: 'change'}
                ],




                futureMajor: [
                    { required: true, message: '请填写', trigger: 'blur'}
                ],
                futureUniversity: [
                    { required: true, message: '请填写', trigger: 'blur'}
                ],
                futureEducation: [
                    { required: true, message: '请填写', trigger: 'blur'}
                ],
                futureConflict: [
                    { required: true, message: '请填写', trigger: 'blur'}
                ],


                studyGradesUp: [
                    { required: true, message: '请填写', trigger: 'blur'}
                ],


                otherPromote: [
                    { type: 'array', required: true, message: '请填写', trigger: 'change'}
                ],
                otherSupplement: [
                    { type: 'array', required: true, message: '请填写', trigger: 'change'}
                ],
                otherAspect: [
                    { required: true, message: '请填写', trigger: 'blur'}
                ]
            }
        }
    },
    methods: {
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if(this.isFinishPop) {
                        this.storeParentCensusQuestion();
                    }else {
                        this.isShowPopup = true;
                    }
                } else {
                    setTimeout(()=>{
                        let isError= document.getElementsByClassName("el-form-item__error");
                        let top = isError[0].offsetTop;     //获取元素到页面最顶点的高度（不会随着页面滚动变化的高度）
                        console.log(top)
                        window.scrollTo(0,top-80);
                    },100);
                    return false;
                }
            });
        },
        // 获取家长是否绑定学生，及绑定的信息
        storeParentCensusQuestion() {
            let _this = this;
            let data = {...this.form};
            let familyTypeRadio = data.familyTypeRadio;
            let isOnlyChildRadio = data.isOnlyChildRadio;
            if(familyTypeRadio!='其他') {
                data.familyType = familyTypeRadio;
            }
            if(isOnlyChildRadio!='不是') {
                data.isOnlyChild = isOnlyChildRadio;
            }
            const params = {
                motherOccupation: data.motherOccupation,
                motherEmployer: data.motherEmployer,
                dadOccupation: data.dadOccupation,
                dadEmployer: data.dadEmployer,
                familyType: data.familyType,
                isOnlyChild: data.isOnlyChild,
                censusQuestion: data,
                status: 3,
            }
            this.$ajax.post(this.G_acapi+this.ports.parent.message.storeParentCensusQuestion,params,{
                headers:{
                    token: window.sessionStorage.getItem('ymtxToken')
                }
            }).then((res)=>{
                if(res.data.code==2000){
                    this.$router.push('/parent/home/quesMessage')
                    if(res.data.code==2000){
                    this.$message({
                        message: '保存成功',
                        type: 'success'
                    });
                    this.isShowBtn = false;
                    this.$store.commit('getParentStatus',3)
                    document.body.scrollIntoView();
                    }else{

                    }
                }else{
                    this.$message({
                        message: res.data.msg,
                        type: 'error'
                    });
                    // console.log(res,'返回错误')
                }
            }).catch(function(error) {
                    console.log(error.message)
                    if(error.message=='Request failed with status code 422'){
                        _this.$message({
                            message: '家庭类型必填，是否独生必填',
                            type: 'error'
                       });
                    }
            })
        },
        // 获取家长是否绑定学生，及绑定的信息
        detailParentInfo() {
            this.$ajax.post(this.G_acapi+this.ports.parent.message.detailParentInfo,{
            },{
                headers:{
                    token: window.sessionStorage.getItem('ymtxToken')
                }
            }).then((res)=>{
                if(res.data.code==2000){
                    let data = res.data.data;
                    if(data.parentName) {
                        this.isShowPopup = false;
                        this.isFinishPop = true;
                        this.parentName = data.parentName;
                    }else {
                        this.isShowPopup = true;
                        this.isFinishPop = false;
                        this.parentName = data.parentName;
                    }
                }
            })
        },
        // 获取已填写家长问卷信息
        detailParentCensusQuestion() {
            this.$ajax.post(this.G_acapi+this.ports.parent.message.detailParentCensusQuestion,{
            },{
                headers:{
                    token: window.sessionStorage.getItem('ymtxToken')
                }
            }).then((res)=>{
                if(res.data.code==2000){
                    let data = res.data.data;
                    this.status = data.status;
                    if(data.censusQuestion) {
                        let familyTypeRadio = data.censusQuestion.familyTypeRadio;
                        let isOnlyChildRadio = data.censusQuestion.isOnlyChildRadio;
                        if(familyTypeRadio!='其他') {
                            data.censusQuestion.familyType = '';
                        }
                        if(isOnlyChildRadio!='不是') {
                            data.censusQuestion.isOnlyChild = '';
                        }
                        this.form= data.censusQuestion;

                    }
                }else{
                    this.$message({
                        message: res.data.msg,
                        type: 'error'
                   });
                }
            })
        },

    },
    computed: {
    },
    watch: {
    },
    created() {
        this.detailParentInfo();
        this.detailParentCensusQuestion();
    },
    mounted() {
    }
}
</script>

<style scoped lang="less">
    .parentQues {
        .content {
            background-color: #fff;
            padding: 30px;
            font-size: 16px;
        }
        .question_title {
            width: 200px;
            height: 40px;
            line-height: 40px;
            padding-left: 30px;
            color: #fff;
            font-size: 18px;
            background-color: #00A4FA;
            position: relative;
            &:after {
                content: '';
                position: absolute;
                right: -30px;
                bottom: 0;
                width: 0;
                height: 0;
                border-width: 0px 30px 40px 30px;
                border-style: solid;
                border-color: transparent transparent #fff transparent;
            }
        }
        .main_box {
            .main {
                padding: 20px 0 50px 30px;
            }
        }

    }
</style>
<style lang="less">
    .parentQues {
        font-size: 16px;
        input {
            border: 1px solid #EAEAEA;
            background-color: #FDFDFD;
        }
        .el-form-item {
            display: flex;
            flex-wrap: wrap;
        }
        .el-form-item__content {
            margin-left: 0 !important;
            flex: 1;
        }
        .student_study {
            .el-form-item {
                margin-bottom: 5px;
                .el-radio__label {
                    display: inline-block;
                    width: 85px;
                }
                .el-checkbox {
                    height: 30px;
                    line-height: 30px;
                }
                .el-checkbox__label {
                    width: 166px;
                }
            }
            .radioBox {
                margin-bottom: 15px;
                input {
                    height: 30px;
                    line-height: 30px;
                }
                .el-radio__label {
                    display: inline;
                }

            }
        }
        .labelBlock {
            .el-form-item__label {
                display: block;;
                width: 100%;
            }
            .el-form-item__content {
                margin-left: 0 !important;
            }
        }

    }
</style>